import {setTextEditorText} from '../../utils/editor';

$(function () {
  /**
   * Bind the resume-parsing prefill to the RESUME dropzone specifically.
   * With file_upload custom fields on the page, instances[0] can be a
   * different (custom field) dropzone depending on field order.
   */
  const resumeDropzoneElement = $('.form-field-file-container[data-file-module="JobSeekerResume"]').get(0);
  const dzInstance = resumeDropzoneElement ? resumeDropzoneElement.dropzone : null;

  if (dzInstance) {

    dzInstance.on('success', function(file, response) {
      nextStep();

      if (response.prefillValues) {
        const prefillValues = response.prefillValues;
        $('.subtitle-container').removeClass('d-none');

        for (const key in prefillValues) {
          const elem = $(`*[name='${key}']`);
          if ($(elem).length > 0) {
            if ($(elem).attr('type') === 'checkbox') {
              $(elem).prop('checked', prefillValues[key]).change();
            } else if ($(elem).hasClass('form-field-rich-text')) {
              if (prefillValues[key]) {
                setTextEditorText($(elem).prev('div').attr('id'), prefillValues[key]);
              }
            } else {
              $(elem).val(prefillValues[key]).change();
            }
          }
        }
      }
    });
  }

  $('.continue-without-resume a').click(function (event) {
    event.preventDefault();
    nextStep();
  });
});

function getAdjacentStepFormId (direction, currentStepFormId) {
  const stepsExistingForApply = window.$steps;
  const currentIndex = stepsExistingForApply.indexOf(currentStepFormId);

  if (currentIndex === -1) return null; // If the active step is not found

  if (direction === 'prev' && currentIndex > 0) {
    return stepsExistingForApply[currentIndex - 1];
  } else if (direction === 'next' && currentIndex < stepsExistingForApply.length - 1) {
    return stepsExistingForApply[currentIndex + 1];
  }

  return null; // No previous or next step available
}

function nextStep() {
  if ($('.form-card-container').length > 1) {
    stepTransition('next');
    $('.submit-apply-regwall-wrapper').removeClass('d-none');
  }
}

function stepTransition(direction) {
  const currentStepFormId = $('.active-step').find('.form-card-container').attr('id');
  const currentStepForm = $(`#${currentStepFormId}`);
  const currentStepFormContainer = currentStepForm.closest('.form-step-container');
  const prevStepFormId = getAdjacentStepFormId('prev', currentStepFormId);
  const nextStepFormId = getAdjacentStepFormId('next', currentStepFormId);

  $(window).scrollTop(0);

  const stepFormContainer = $(`#${direction === 'next' ? nextStepFormId : prevStepFormId}`).closest('.form-step-container');
  stepFormContainer.addClass('active-step');

  const width = currentStepFormContainer.outerWidth();
  const translateX = -width; // Calculate the translate x value

  $('.form-steps').css({'--translate-x': `${translateX}px`}).addClass(direction === 'next' ? 'slide-left' : 'slide-right');
  $('.form-step-container').css({'max-width': `${width}px`});

  $('.form-steps').one('animationend', () => {
    $('.form-steps').css({'--translate-x': ``}).removeClass(direction === 'next' ? 'slide-left' : 'slide-right');
    currentStepFormContainer.removeClass('active-step');
    $('.form-step-container').css({'max-width': ''});
  });
}
